import { createFileRoute, redirect } from '@tanstack/react-router';

type PortfolioIndexBeforeLoadArgs = {
  params: {
    loopId: number;
    org: string;
  };
};

export const portfolioIndexBeforeLoad = ({ params }: PortfolioIndexBeforeLoadArgs): never => {
  throw redirect({
    to: '/org/$org/loop/$loopId/portfolio/table',
    params,
    search: true,
    replace: true,
  });
};

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/')({
  beforeLoad: portfolioIndexBeforeLoad,
});
